import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { useContent } from "../lib/api";

export default function Blog() {
  const { data: blogs } = useContent("blogs");
  const [tag, setTag] = useState("All");
  const tags = ["All", ...Array.from(new Set(blogs.map((b) => b.tag)))];
  const shown = tag === "All" ? blogs : blogs.filter((b) => b.tag === tag);

  return (
    <div data-testid="blog-page">
      <PageHeader overline="The Journal" title={<>Notes &amp;<br />Myth Busting</>}
        subtitle="Honest, evidence-based takes on training, nutrition and the myths holding you back." />
      <section className="mx-auto max-w-[1400px] px-5 lg:px-8 py-14 md:py-20">
        <div className="flex flex-wrap gap-2.5 mb-10">
          {tags.map((t) => (
            <button key={t} data-testid={`blog-filter-${t.toLowerCase().replace(/\s/g,'-')}`} onClick={() => setTag(t)}
              className={`px-5 py-2.5 rounded-full text-xs uppercase tracking-[0.12em] font-bold border transition-colors ${tag === t ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary"}`}>{t}</button>
          ))}
        </div>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {shown.map((b, i) => (
            <Reveal key={b.id} delay={(i % 3) * 0.07}>
              <Link to={`/blog/${b.id}`} data-testid="blog-card" className="group flex flex-col border border-border rounded-lg overflow-hidden bg-card h-full hover:border-primary transition-colors">
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={b.image} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.15em] font-bold">
                    <span className="text-primary">{b.tag}</span>
                    <span className="flex items-center gap-1 text-muted-foreground"><Clock size={12} /> {b.read_time}</span>
                  </div>
                  <h2 className="font-display font-700 uppercase text-2xl tracking-tight mt-2 leading-tight">{b.title}</h2>
                  <p className="text-muted-foreground text-sm mt-2 line-clamp-3 flex-1">{b.excerpt}</p>
                  <span className="inline-flex items-center gap-2 mt-4 text-xs uppercase tracking-[0.15em] font-bold group-hover:text-primary transition-colors">Read <ArrowUpRight size={14} /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
